import * as React from "react";
const SvgRetry20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M9.913 1.929c-2.577 0-4.956 1.252-6.459 3.255v-2.9H1.367v6.532H7.91V6.729H4.925c1.096-1.66 2.953-2.713 4.988-2.713a5.996 5.996 0 0 1 5.99 5.99 5.98 5.98 0 0 1-5.99 5.978c-3.015 0-5.572-2.254-5.937-5.238l-2.066.26c.5 4.029 3.944 7.065 8.014 7.065 4.455 0 8.076-3.62 8.076-8.066C18 5.56 14.369 1.93 9.913 1.93Z"
    })
  );
export default SvgRetry20Px;
